(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["halohaus-welcome-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('hh-welcome');
  const reopen = document.getElementById('hh-welcome-reopen');
  if (!dialog || !reopen || typeof dialog.showModal !== 'function') return;
  const key = 'halohaus-welcome-dismissed';
  const success = !!dialog.querySelector('[data-hh-success]');
  const errors = !!dialog.querySelector('[data-hh-errors]');
  let shown = false;
  try { shown = Date.now() - Number(localStorage.getItem(key) || 0) < 7 * 86400000; } catch {}
  const open = () => { if (!dialog.open) dialog.showModal(); };
  const close = () => { dialog.close(); try { localStorage.setItem(key, String(Date.now())); } catch {} };
  dialog.querySelector('.hh-welcome__close').addEventListener('click', close);
  dialog.querySelector('.hh-welcome__later')?.addEventListener('click', close);
  dialog.addEventListener('cancel', () => { try { localStorage.setItem(key, String(Date.now())); } catch {} });
  dialog.addEventListener('click', event => {
    const rect = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) close();
  });
  reopen.addEventListener('click', open);
  if (success || errors) open();
  if (!success) {
    reopen.hidden = false;
    if (!shown && !window.Shopify?.designMode) setTimeout(open, 5000);
  } else {
    try { localStorage.setItem(key, String(Date.now())); } catch {}
  }
})();
  } catch(e) { console.error(e); }
})();

})();
